document.addEventListener('DOMContentLoaded', function() {
    const body = document.body;
    const toggleNavCheckbox = document.getElementById('toggle-nav');
    const mobileNav = document.getElementById('mobile-nav');

    // Add event listener to the checkbox
    toggleNavCheckbox.addEventListener('change', function() {
        // Check if the checkbox is checked
        if (toggleNavCheckbox.checked) {

            body.style.overflow = 'hidden'
            mobileNav.classList.add('active');

        } else {

            body.style.overflow = 'scroll'
            mobileNav.classList.remove('active');
            
        }
    });


    var parentMenus = document.querySelectorAll('.menu-item-has-children');

    parentMenus.forEach(function(parentMenu) {

        parentMenu.addEventListener('click', function() {
            var submenu = this.querySelector('.mobile-submenu-container');
            if (submenu) {
                if (submenu.style.visibility === 'hidden' || submenu.style.display === '') {

                    submenu.classList.add('active');

                } else {

                    submenu.classList.remove('active');

                }
            }
        });

        var submenuClose = parentMenu.querySelector('.submenu-close');

        if (submenuClose) {
            submenuClose.addEventListener('click', function(event) {
                event.stopPropagation(); // Prevent parentMenu from being toggled
                var submenu = parentMenu.querySelector('.mobile-submenu-container');
                if (submenu) {
                    submenu.classList.remove('active');
                }
            });
        }

    });



});
